import styled from 'styled-components';
import { FormGrid, FormGroup, Input } from '../../../../style';

export const DimensionsGrid = styled(FormGrid)`
  margin-top: 16px;
`;

export const FullRowFormGroup = styled(FormGroup)`
  grid-column: span 3;
`;

export const CalcHint = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #696969;
`;

// Campo composto: valor da dimensão à esquerda, par de tolerância empilhado à direita,
// nos 38px que o globalStyle dá a todo input do sistema.
export const DimensionField = styled.div`
  display: flex;
  align-items: stretch;
  height: 38px;
  box-sizing: border-box;
  background-color: #EBEBEB;
  border: 1px solid transparent;
  border-radius: 20px;
  overflow: hidden;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:focus-within {
    border-color: #3B82F6;
    box-shadow: 0 0 0 1px #3B82F6;
  }
`;

export const DimensionValueInput = styled.input`
  flex: 1;
  min-width: 0;
  border: 0;
  outline: none;
  background: transparent;
  color: #696969;
  font-family: 'Inter', sans-serif;
  appearance: textfield;
  -moz-appearance: textfield;

  && {
    height: 100% !important;
    padding: 0 12px !important;
    font-size: 12px !important;
    line-height: normal !important;
  }

  &::placeholder { color: #9A9A9A; }
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
`;

export const ToleranceSeparator = styled.div`
  flex: none;
  width: 1px;
  margin: 6px 0;
  background: #D4D4D4;
`;

export const TolerancePair = styled.div`
  flex: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 92px;
  padding: 0 12px 0 10px;
  box-sizing: border-box;
`;

export const ToleranceRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  height: 15px;
`;

export const ToleranceRowDivider = styled.div`
  height: 1px;
  background: #D4D4D4;
`;

export const ToleranceSign = styled.span`
  flex: none;
  font-family: 'Inter', sans-serif;
  font-size: 11px;
  line-height: 15px;
  color: #696969;
`;

export const ToleranceInput = styled.input`
  flex: 1;
  min-width: 0;
  margin: 0;
  border: 0;
  outline: none;
  background: transparent;
  text-align: right;
  color: #696969;
  font-family: 'Inter', sans-serif;
  appearance: textfield;
  -moz-appearance: textfield;

  && {
    height: 15px !important;
    padding: 0 !important;
    font-size: 11px !important;
    line-height: 15px !important;
  }

  &::placeholder { color: #9A9A9A; }
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
`;

export const BlockInput = styled(Input)`
  height: 42px;
  box-sizing: border-box;
`;

export const WeightField = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 42px;
  padding: 0 10px 0 12px;
  box-sizing: border-box;
  background-color: #EBEBEB;
  border: 1px solid transparent;
  border-radius: 20px;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:focus-within {
    border-color: #3B82F6;
    box-shadow: 0 0 0 1px #3B82F6;
  }
`;

export const WeightInput = styled.input`
  flex: 1;
  min-width: 0;
  height: 100%;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  color: #696969;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  -moz-appearance: textfield;

  &::placeholder { color: #9A9A9A; }
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
`;

export const CalcBadge = styled.span`
  flex: none;
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 10px;
  border-radius: 10px;
  background: #DDE9F7;
  color: #1F4E8C;
  font-family: 'Inter', sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

export const CalculatedValue = styled.div`
  display: flex;
  align-items: center;
  min-height: 42px;
  padding: 8px 12px;
  background: #f4f6f8;
  border: 1px solid #dfe3e8;
  border-radius: 6px;
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  color: #1f2937;
`;
